import {
  CurtainConfiguration,
  HeadingType,
  MadeToMeasureConfiguration,
  RomanBlindConfiguration,
} from "@/components/MadeToMeasureForm/configurationTypes";
import styles from "./ReviewModalBasketSummary.module.scss";
import { ConfigurationRequirementsType } from "@/types/prodcatBaseTypes";
import { formatM2MTitle } from "@/utils/product/formatM2MTitle";

const getBasketConfigurationValues = (
  configurationReqType: ConfigurationRequirementsType,
  configuration: MadeToMeasureConfiguration,
) => {
  if (configurationReqType === "MadeToMeasureRomanBlind") {
    const config = configuration as RomanBlindConfiguration;
    return (
      <>
        <li>Stacking Style: {config.stackingStyle}</li>
        <li>Chain side: {config.controlSide}</li>
        <li>
          Measurements: {config.width}cm (w) x {config.height}cm (h)
        </li>
        <li>Installation height: {config.installationHeight}cm</li>
        <li>Lining Weight: {config.liningWeight}</li>
        <li>Lining Colour: {config.liningColour}</li>
      </>
    );
  }

  if (configurationReqType === "MadeToMeasureCurtain") {
    const config = configuration as CurtainConfiguration;
    return (
      <>
        <li>Heading Type: {config.headingType}</li>
        {config.headingType === HeadingType.Eyelet && config.eyeletColour && (
          <li>Eyelet Colour: {config.eyeletColour}</li>
        )}
        <li>Curtain Type: {config.typeOfCurtain}</li>
        <li>Width of track or pole: {config.lengthOfTrackOrPole}cm</li>
        <li>Drop: {config.eyeDrop}cm</li>
        <li>Lining Weight: {config.liningWeight}</li>
        <li>Lining Colour: {config.liningColour}</li>
      </>
    );
  }

  return null;
};

type BasketSummaryProps = {
  quantity: number;
  title: string;
  configReqType: ConfigurationRequirementsType;
  configuration: MadeToMeasureConfiguration;
};

export const ReviewModalBasketSummary = ({
  quantity,
  title,
  configReqType,
  configuration,
}: BasketSummaryProps) => {
  const basketConfig = getBasketConfigurationValues(
    configReqType,
    configuration,
  );
  return (
    <div className={styles.summary} data-testid="m2m-review-a2b-summary">
      <h2 className={styles.summary__header}>Added to your basket:</h2>
      <ul className={styles.summary__details}>
        <li>
          {quantity} x{" "}
          {formatM2MTitle(title, configReqType === "MadeToMeasureRomanBlind")}
        </li>
        {basketConfig}
      </ul>
    </div>
  );
};
